//
//
//
//
//
//
//

import toDay from './components/toDay';
import transactionFrom from './components/transaction';
export default {
  name: 'index',
  components: {
    toDay: toDay,
    transactionFrom: transactionFrom
  }
};